import script from "./AddGroupUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddGroupUser.vue?vue&type=script&setup=true&lang=ts"

import "./AddGroupUser.vue?vue&type=style&index=0&id=2ab122bd&scoped=true&lang=scss"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab122bd"]])

export default __exports__